export default class DownloadDocument {
    constructor(element) {
        this.selector = element;

        this.chooseDocument();
    }

    chooseDocument() {
        const form = this.selector.querySelector('[data-form]');
        const select = form.querySelector('[name="documents"]');
        const button = form.querySelector('[type="submit"]');

        select.addEventListener('change', () => {
            const isValid = select.value !== '-';
            button.disabled = !isValid;

            if (isValid) {
                form.action = select.value;
            }
        });
    }
}